/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/* eslint-disable
    one-var,
    prefer-const,
    radix
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import $ from 'jquery';
import React from 'react';
import _ from 'underscore';

import EditableComponent from 'notebook/mediocre/core-ui/EditableComponent';
import {BenchlingSelection, SelectionRestoreData} from 'notebook/mediocre/selection/SelectionStore';
import * as selutil from 'notebook/mediocre/selection/text/SelUtil';
import * as keyboard from 'util/Keyboard';
import {ElementKeyboardEvent} from 'util/Types';

interface ParsedTime {
  h: number;
  html: string;
  m: number;
  raw: string;
  s: number;
  time: number | null;
}

export interface TimeEditableProps {
  className?: string;
  cid: string;
  index: number;
  visible?: boolean;
  placeholderZeros: boolean;
  time_seconds?: number | null;
  showSeconds: boolean;
  locked?: boolean;
  enterHandler?: () => void;
  updateTimeHandler?: (time: number | null) => void;
  setSelection?: (selection: SelectionRestoreData) => void;
  storeState?: (args: {selection: BenchlingSelection}) => void;
  restoreState?: (
    e: ElementKeyboardEvent,
    selectionRestoreData: {selection: SelectionRestoreData}
  ) => boolean;
  isMultiEditable: boolean;
  rootRef?: React.RefObject<HTMLElement>;
}

type State = any;

class TimeEditable extends React.Component<TimeEditableProps, State> {
  static computeCid(cid: any): string {
    return `time-${cid}`;
  }

  static defaultProps = {
    index: 0,
    visible: true,
    placeholderZeros: true,
    showSeconds: true,
    isMultiEditable: false,
  };

  contentEditableRef = React.createRef<React.ComponentRef<typeof EditableComponent>>();
  rootRef = React.createRef<HTMLElement>();

  _getRootRef(): React.RefObject<HTMLElement> {
    return this.props.rootRef ?? this.rootRef;
  }

  override UNSAFE_componentWillReceiveProps(nextProps: TimeEditableProps): void {
    // If the parent has set a new time_seconds we should reset our state,
    // otherwise, the user's input represents the value already.
    if (this.state.time !== nextProps.time_seconds) {
      this.setState(this._parseTimeSeconds(nextProps.time_seconds));
    }
  }

  processInput = (text: string, param?: any): ParsedTime => {
    // Generates state from the user input

    // Ignore non-digit characters
    if (param == null) {
      param = {};
    }
    const {placeHolderZeros} = param;
    // eslint-disable-next-line no-restricted-syntax
    text = _.filter(text, (c) => '0' <= c && c <= '9').join('');

    if (text.length === 0) {
      if (this.props.placeholderZeros || placeHolderZeros) {
        text = '0';
      } else {
        // # Instead of filling in 0's, return empty so we can use CSS placeholder logic.
        return {
          time: null,
          html: '',
          h: 0,
          m: 0,
          s: 0,
          raw: '',
        };
      }
    }

    // Restrict to 6 characters, pad with 0's if necessary.
    text = text.slice(-6);
    text = '000000'.slice(text.length) + text;
    const raw = text;

    // Parse into numerical representation
    const h = parseInt(text.slice(0, 2));
    const m = parseInt(text.slice(2, 4));
    const s = parseInt(text.slice(4));
    const time = (h * 60 + m) * 60 + s;

    // Render HTML, with leading 0's wrapped in a stylable span.
    let isFiller = true;

    function consumeDigit(): string {
      const c = text[0];
      text = text.slice(1);
      if (c !== '0') {
        isFiller = false;
        return c;
      } else if (isFiller) {
        return '<span class="zero">0</span>';
      } else {
        return '0';
      }
    }

    const ht = consumeDigit() + consumeDigit();
    const mt = consumeDigit() + consumeDigit();
    const st = consumeDigit() + consumeDigit();

    const secondsHiddenClass = this.props.showSeconds ? '' : 'hidden';
    const html = `<span class='hr  section'>${ht}</span>\
<span class='min section'>${mt}</span>\
<span class='sec section ${secondsHiddenClass}'>${st}</span>`;
    return {
      time,
      html,
      h,
      m,
      s,
      raw,
    };
  };

  updateHandler = (e: any, param: any): void => {
    let lengthChange;
    if (param == null) {
      param = {};
    }
    let {arrowPressed, placeHolderZeros, selection} = param;
    const {text} = e; // user-inputted text
    const newState = this.processInput(text, {placeHolderZeros});
    const {time, raw} = newState;

    // If the user hits the up arrow while the time is empty, we want the cursor
    // to stay at the end.
    if (this.state.raw.length === 0 && arrowPressed) {
      lengthChange = raw.length;
    } else {
      lengthChange = raw.length - text.length;
    }

    if (selection == null) {
      selection = selutil.getSelectionIndices();
    }
    selection.start += lengthChange;
    selection.end += lengthChange;
    this.setState(newState, () => {
      // Wait until the state gets set, so we can access newState as @state
      // in componentWillReceiveProps
      this.props.updateTimeHandler!(time);
      this.props.setSelection!(selection);
      this.contentEditableRef.current!.forceContentEditableUpdate();
    });
  };

  blurHandler = (e: any): void => {
    // Format correctly based on the state.
    this.setState(this._parseTimeSeconds(this.props.time_seconds));
  };

  pasteHandler = (e: any): void => {
    // Pasting text should resemble typing the contents of the clipboard, so we keep the last 6 chars after
    // the paste since input shifts content left + truncates.
    const pasted = e.originalEvent.clipboardData.getData('text/plain').split('\n').join('');
    const text = (e.before + pasted + e.after).slice(-6);
    const pos = text.length - e.after.length;
    this.updateHandler(
      {text},
      {selection: {cid: TimeEditable.computeCid(this.props.cid), start: pos, end: pos}}
    );
  };

  arrowKeydown = (e: any): void => {
    let magnitude, sign;
    switch (e.which) {
      case 40: // down
        sign = -1;
        break;
      case 38: // up
        sign = 1;
        break;
      default:
        return;
    }
    e.preventDefault();

    // Determine if we are inside a hr/min/sec section.
    // If we are, update the hr/min/sec depending on which arrow key was pressed.
    let {time} = this.state;
    if (time == null) {
      time = 0;
      magnitude = 1;
    } else {
      const span = selutil.closest(this._getRootRef().current!, 'span.section');
      if (span == null) {
        return;
      }
      magnitude = (() => {
        if ($(span).hasClass('hr')) {
          return 60 * 60;
        } else if ($(span).hasClass('min')) {
          return 60;
        } else if ($(span).hasClass('sec')) {
          return 1;
        }
        return undefined;
      })();
    }
    // @ts-expect-error Introduced by Typescript 5.1 upgrade. magnitude is possibly undefined, and a ! type
    // assertion causes an eslint error.
    time += sign * magnitude;
    const [h, m, s] = Array.from(this._hms(time));

    this.updateHandler({text: this._format(h, m, s)}, {arrowPressed: true});
  };

  _hms = (timeSeconds: any): [number, number, number] => {
    let seconds = Math.max(0, timeSeconds);
    let minutes = Math.floor(seconds / 60);
    seconds -= minutes * 60;
    const hours = Math.floor(minutes / 60);
    minutes -= hours * 60;
    if (hours > 99) {
      minutes = 59;
      seconds = 59;
    }
    return [hours, minutes, seconds];
  };

  _parseTimeSeconds = (timeSeconds: any): ParsedTime => {
    const input = (() => {
      if (timeSeconds) {
        const [hours, minutes, seconds] = Array.from(this._hms(timeSeconds));
        return this._format(hours, minutes, seconds);
      } else {
        return '';
      }
    })();
    return this.processInput(input);
  };

  _format = (h: number, m: number, s: number): string => {
    function pad(a: number): string {
      // 2-digit number padding
      if (a < 10) {
        return `0${a}`;
      }
      return `${a}`;
    }

    // Helper to simulate user input based on minutes and seconds.
    const fh = pad(h);
    const fm = pad(m);
    const fs = pad(s);
    return `${fh}${fm}${fs}`;
  };

  deleteHandler = (e: any): true | undefined => {
    // HACK: TimeEditable is hidden when empty and not focused... handling delete all on the
    // input event results in the component briefly losing focus and because it is now empty,
    // it will be hidden (at which point focus cannot be returned to it). So instead, we ensure
    // that instead of being left empty, that it is filled with 0's.
    if (keyboard.isADeleteKey(e)) {
      const {start, end} = selutil.getSelectionIndices()!;
      if (start === 0 && end === 6) {
        this.updateHandler({text: ''}, {placeHolderZeros: true});
        return true;
      }
    }

    if (keyboard.isEnterKey(e)) {
      if (typeof this.props.enterHandler === 'function') {
        this.props.enterHandler();
      }
    }
    return undefined;
  };

  override state: State = this._parseTimeSeconds(this.props.time_seconds);

  override render(): JSX.Element {
    const classes = classNames(this.props.className, {
      'time-editable': true,
      'force-visible': this.props.visible,
      'multi-editable': this.props.isMultiEditable,
    });
    return (
      <EditableComponent
        // eslint-disable-next-line no-restricted-syntax
        {..._.extend({}, this.props, {
          ref: this.contentEditableRef,
          rootRef: this._getRootRef(),
          allowHTML: true,
          className: classes,
          cid: TimeEditable.computeCid(this.props.cid), // the corresponding step is already using @props.step.cid
          index: this.props.index,
          text: this.state.html,
          updateHandler: this.updateHandler,
          pasteHandler: this.pasteHandler,
          arrowKeydown: this.arrowKeydown,
          blurHandler: this.blurHandler,
          keyDownHook: this.deleteHandler,
        })}
      />
    );
  }
}

export default TimeEditable;
